export class CurrentStatusResponse {
	user: number;
	activeCourse: number;
	lastLessonBlock: number;
}
